import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class TemplateApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'archive-template'
  }

}